// extracted by mini-css-extract-plugin
export var content = "_v7-1";
export var wrapper = "_v7-0";